import {reactive, ref, shallowRef} from 'vue'
import api from "../services/api.js";
import crypt from "../services/crypt.js";

import Clue2 from "../views/Clue2.vue"
import Clue3 from "../views/Clue3.vue"
import Clue4 from "../views/Clue4.vue"
import Submit from "../views/Submit.vue"

const session = shallowRef({})
const modalIsOpen = shallowRef(false)
const isLoading = shallowRef(false)
const currentRoute = shallowRef(Clue2)
const routes = [
    { name: 'clue-2', component: Clue2 },
    { name: 'clue-3', component: Clue3 },
    { name: 'clue-4', component: Clue4 },
    { name: 'submit', component: Submit },
]



export default function useScavenge() {

    const closeModal = () => {
        const scrollY = document.body.style.top
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.left = '0px'
        document.body.style.right = '0px'
        window.scrollTo(0, parseInt(scrollY || '0') * -1)
        modalIsOpen.value = false
    }

    const openModal = (view) => {

		let route = routes.find(r => r.name === view)
		if(!route) {
			throw new Error('route not found')
		}
		currentRoute.value = route.component

        document.body.style.top = `-${window.scrollY}px`
        document.body.style.left = '0px'
        document.body.style.right = '0px'
        document.body.style.position = 'fixed'
        modalIsOpen.value = true
    }

	const changeModal = (view) => {
		let route = routes.find(r => r.name === view)
		if(!route) {
			throw new Error('route not found')
		}
		currentRoute.value = route.component
	}

    const getSession = async () => {
		await api.get('/session')
			.then(r => {
				if(r.multiverse) {
					session.value = crypt.decrypt('NopeNeverGwenIsAliveAndTheBest##', r.multiverse)
				}
			})
	}
    const claimClue = (clueNum) => {
		let encrypted = crypt.encrypt('NopeNeverGwenIsAliveAndTheBest##', {gwen: clueNum})
		let stringyString = btoa(JSON.stringify(encrypted))
		return api.post('/clue', {
			multiverse: stringyString
		}).then(r => {
			if(r.multiverse) {
				session.value = crypt.decrypt('NopeNeverGwenIsAliveAndTheBest##', r.multiverse)
			}
		})
	}

	const submitEntry = (user) => {
		return api.post('/enter', user)
	}

    const toggleLoader = (value) => isLoading.value = value

    return {
		session,
        modalIsOpen,
        currentRoute,
        isLoading,

		submitEntry,
        closeModal,
        openModal,
		changeModal,
        getSession,
        claimClue,
        toggleLoader
    }

}
